import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import Drawer from 'react-modern-drawer';
import cachingMechanisum from "components/Common/cachingMechanisum";
import TransactionServices from "../TransactionServices";
import ExportOption from "components/Common/exportOption";

export default function InvoiceCheckBox(param: any) {
    console.log(param)

    let [disney, setdisney] = useState(false);
    let [headerType, setHeaderType] = useState("");
    let [createAlert, setcreateAlert] = useState(false);
    let [exportOption, setExportOption] = useState(false);
    let [exportOptionType, setExportOptionType] = useState("");
    let [InvoiceCheckCount, setInvoiceCheckCount] = useState(0);
    let [openPeriodList, setopenPeriodList] = useState<any>([]);
    let [periodSelected, setPeriodSelected] = useState("20241231");
    let [InvoiceCheckDetail, setInvoiceCheckDetail] = useState<any>([]);

    useEffect(() => {
        if (param?.headerType == 1) { headerType = "publishingSong" }
        if (param?.headerType == 2) { headerType = "publishingWriter" }
        if (param?.headerType == 3) { headerType = "digital" }
        if (param?.headerType == 4) { headerType = "physical" }
        if (param?.headerType == 5) { headerType = "costs" }
        if (param?.headerType == 6) { headerType = "advances" }
        if (param?.headerType == 7) { headerType = "licensing" }
        if (param?.headerType == 8) { headerType = "adjustments" }

        setHeaderType(headerType);
        invoiceList();

        var periodListCache = cachingMechanisum.getCachingStorage("SystemPeriod");
        openPeriodList = periodListCache;
        setopenPeriodList(openPeriodList);

        periodSelected = periodListCache?.filter((e: any) => e.periodCurrent == 1)[0].periodDesc
        setPeriodSelected(periodSelected)
    }, [param.param])


    const invoiceList = () => {
        var payload = {
            headerType: headerType, royaltyPeriod: periodSelected,
            accountCode: "", invoiceNum: "", approvalStatus: "",
            pageNumber: 1, pageSize: 10
        }

        TransactionServices.getInvoiceCheckDetails(payload).then((respond: any) => {
            InvoiceCheckDetail = respond;
            setInvoiceCheckDetail(InvoiceCheckDetail)
            InvoiceCheckCount = respond[0]?.totalRows
            setInvoiceCheckCount(InvoiceCheckCount)
        })
    }

    const onClose = () => { param.InvoiceCheckClose(); }

    const exportOptionSelect = (e: any) => {
        exportOptionType = e
        setExportOptionType(exportOptionType)

        exportOption = true;
        setExportOption(exportOption)
    }

    const onChangeExportOption = (e: any) => {
        console.log(e)

        if (e.optSts === 1) {

            var payload = {
                pageNumber: -1,
                pageSize: -1,
                type: param.subType,
                fileFormat: e.fileFormat,
                numRows: e.numRows,
                fileName: e.fileName,

            }
        }

        exportOption = false;
        setExportOption(exportOption)
    }

    return (
        <>

            <Drawer open={param.param} direction='right' className='react-drawer allowVscroll allowHscroll' size={800}>
                <div className="box noBorderRadius noBorder ws-9 pull-right landing allowVscroll allowHscroll">
                    <div className="box-header-main">
                        <h2 >  Invoice Check  </h2>
                    </div>

                    <div className="box-content">
                        {createAlert && <div className="alert alert-ino">An entry has been created for this invoice</div>}

                        <div className="ws-12">

                            <div className="ws-3 pm">
                                <div className="input-group">
                                    <span className="ws-12 text-bold">Select Period</span>
                                    <select className="ws-12" ng-model="quarterlyPeriod" ng-change="onInvoiceCheckLevel1()" ng-options="item.periodDesc as ((item.periodFrom | date : dateformat) + ' - ' + (item.periodTo | date : dateformat)) for item in items"><option value="0" selected label="Jan 1, 2014 - Mar 31, 2014">Jan 1, 2014 - Mar 31, 2014</option><option value="1" label="Apr 1, 2014 - Jun 30, 2014">Apr 1, 2014 - Jun 30, 2014</option><option value="2" label="Jul 1, 2014 - Sep 30, 2014">Jul 1, 2014 - Sep 30, 2014</option><option value="3" label="Oct 1, 2014 - Dec 31, 2014">Oct 1, 2014 - Dec 31, 2014</option><option value="4" label="Jan 1, 2015 - Mar 31, 2015">Jan 1, 2015 - Mar 31, 2015</option><option value="5" label="Apr 1, 2015 - Jun 30, 2015">Apr 1, 2015 - Jun 30, 2015</option><option value="6" label="Jul 1, 2015 - Sep 30, 2015">Jul 1, 2015 - Sep 30, 2015</option><option value="7" label="Oct 1, 2015 - Dec 31, 2015">Oct 1, 2015 - Dec 31, 2015</option><option value="8" label="Jan 1, 2016 - Mar 31, 2016">Jan 1, 2016 - Mar 31, 2016</option><option value="9" label="Apr 1, 2016 - Jun 30, 2016">Apr 1, 2016 - Jun 30, 2016</option><option value="10" label="Jul 1, 2016 - Sep 30, 2016">Jul 1, 2016 - Sep 30, 2016</option><option value="11" label="Oct 1, 2016 - Dec 31, 2016">Oct 1, 2016 - Dec 31, 2016</option><option value="12" label="Jan 1, 2017 - Mar 31, 2017">Jan 1, 2017 - Mar 31, 2017</option><option value="13" label="Apr 1, 2017 - Jun 30, 2017">Apr 1, 2017 - Jun 30, 2017</option><option value="14" label="Jul 1, 2017 - Sep 30, 2017">Jul 1, 2017 - Sep 30, 2017</option><option value="15" label="Oct 1, 2017 - Dec 31, 2017">Oct 1, 2017 - Dec 31, 2017</option><option value="16" label="Jan 1, 2018 - Mar 31, 2018">Jan 1, 2018 - Mar 31, 2018</option><option value="17" label="Apr 1, 2018 - Jun 30, 2018">Apr 1, 2018 - Jun 30, 2018</option><option value="18" label="Jul 1, 2018 - Sep 30, 2018">Jul 1, 2018 - Sep 30, 2018</option><option value="19" label="Oct 1, 2018 - Dec 31, 2018">Oct 1, 2018 - Dec 31, 2018</option><option value="20" label="Jan 1, 2019 - Mar 31, 2019">Jan 1, 2019 - Mar 31, 2019</option><option value="21" label="Apr 1, 2019 - Jun 30, 2019">Apr 1, 2019 - Jun 30, 2019</option><option value="22" label="Jul 1, 2019 - Sep 30, 2019">Jul 1, 2019 - Sep 30, 2019</option><option value="23" label="Oct 1, 2019 - Dec 31, 2019">Oct 1, 2019 - Dec 31, 2019</option><option value="24" label="Jan 1, 2020 - Mar 31, 2020">Jan 1, 2020 - Mar 31, 2020</option><option value="25" label="Apr 1, 2020 - Jun 30, 2020">Apr 1, 2020 - Jun 30, 2020</option><option value="26" label="Jul 1, 2020 - Sep 30, 2020">Jul 1, 2020 - Sep 30, 2020</option><option value="27" label="Oct 1, 2020 - Dec 31, 2020">Oct 1, 2020 - Dec 31, 2020</option><option value="28" label="Jan 1, 2021 - Mar 31, 2021">Jan 1, 2021 - Mar 31, 2021</option><option value="29" label="Apr 1, 2021 - Jun 30, 2021">Apr 1, 2021 - Jun 30, 2021</option><option value="30" label="Jul 1, 2021 - Sep 30, 2021">Jul 1, 2021 - Sep 30, 2021</option><option value="31" label="Oct 1, 2021 - Dec 31, 2021">Oct 1, 2021 - Dec 31, 2021</option><option value="32" label="Jan 1, 2022 - Mar 31, 2022">Jan 1, 2022 - Mar 31, 2022</option><option value="33" label="Apr 1, 2022 - Jun 30, 2022">Apr 1, 2022 - Jun 30, 2022</option><option value="34" label="Jul 1, 2022 - Sep 30, 2022">Jul 1, 2022 - Sep 30, 2022</option><option value="35" label="Oct 1, 2022 - Dec 31, 2022">Oct 1, 2022 - Dec 31, 2022</option><option value="36" label="Jan 1, 2023 - Mar 31, 2023">Jan 1, 2023 - Mar 31, 2023</option><option value="37" label="Apr 1, 2023 - Jun 30, 2023">Apr 1, 2023 - Jun 30, 2023</option><option value="38" label="Jul 1, 2023 - Sep 30, 2023">Jul 1, 2023 - Sep 30, 2023</option><option value="39" label="Oct 1, 2023 - Dec 31, 2023">Oct 1, 2023 - Dec 31, 2023</option><option value="40" selected label="Jan 1, 2024 - Mar 31, 2024">Jan 1, 2024 - Mar 31, 2024</option><option value="41" label="Apr 1, 2024 - Jun 30, 2024">Apr 1, 2024 - Jun 30, 2024</option><option value="42" label="Jul 1, 2024 - Sep 30, 2024">Jul 1, 2024 - Sep 30, 2024</option><option value="43" label="Oct 1, 2024 - Dec 31, 2024">Oct 1, 2024 - Dec 31, 2024</option><option value="44" label="Jan 1, 2025 - Mar 31, 2025">Jan 1, 2025 - Mar 31, 2025</option><option value="45" label="Apr 1, 2025 - Jun 30, 2025">Apr 1, 2025 - Jun 30, 2025</option><option value="46" label="Jul 1, 2025 - Sep 30, 2025">Jul 1, 2025 - Sep 30, 2025</option><option value="47" label="Oct 1, 2025 - Dec 31, 2025">Oct 1, 2025 - Dec 31, 2025</option><option value="48" label="Jan 1, 2026 - Jun 30, 2026">Jan 1, 2026 - Jun 30, 2026</option><option value="49" label="Jul 1, 2026 - Dec 31, 2026">Jul 1, 2026 - Dec 31, 2026</option><option value="50" label="Jan 1, 2027 - Jun 30, 2027">Jan 1, 2027 - Jun 30, 2027</option><option value="51" label="Jul 1, 2027 - Dec 31, 2027">Jul 1, 2027 - Dec 31, 2027</option></select>
                                </div>
                            </div>

                            <div className="ws-3 pm">
                                <div className="input-group">
                                    <span className="ws-12 text-bold">Account</span>
                                    <select className="ws-12" ng-model="invoiceCheckDSP" ng-change="onInvoiceCheckLevel1()" ng-options="dsp.accountCode as dsp.accountCode for dsp in invoiceCheckDSPList">
                                        <option value="" >Choose an account</option>
                                        <option value="0" label="All">All</option>
                                    </select>
                                </div>
                            </div>

                            <div className="ws-2 pm">
                                <div className="input-group">
                                    <span className="ws-12 text-bold">status</span>
                                    <select className="ws-12" ng-model="invoiceApprovedStatus" ng-change="onInvoiceCheckLevel1()">
                                        <option value="" >Select status</option>
                                        <option value="1" >Approved</option>
                                        <option value="0" >Not Approved</option>
                                    </select>
                                </div>
                            </div>

                            <div className="ws-4 mtxl">
                                <button className="icon-btn primary btn-s" onClick={() => exportOptionSelect("Custom Accounts")} ng-click="exportPopupOptions(1, invoiceCheckDSP)" title="Custom Accounts Export"><i className="icon-download1"></i> </button>
                                <button className="icon-btn primary  btn-s" onClick={() => exportOptionSelect("Custom disney")} ng-click="exportPopupOptions(1, invoiceCheckDSP, 'netsuite', '')"><i className="icon-download1"></i>
                                    {!disney && <span>Custom Netsuite Export</span>}
                                    {disney && <span>Custom SAP Export</span>}
                                </button>
                            </div>

                        </div>

                    </div>

                    <div className="box-content">
                        {InvoiceCheckCount == 0 && <div className="alert alert-info ">No records found</div>}

                        {InvoiceCheckCount > 0 && <div className="ws-12 allowHscroll allowVscroll">

                            {InvoiceCheckCount > 0 && <table className="newTable">
                                <thead>
                                    <tr>
                                        <th className="forceSingleLine">Account Code</th>
                                        <th className="forceSingleLine">Invoice Number</th>
                                        <th className="forceSingleLine">Royalty Period</th>
                                        <th className="forceSingleLine">Home Value</th>
                                        <th className="forceSingleLine">Net Amount Processed</th>
                                        <th className="forceSingleLine">Amount Paid Out</th>
                                        <th className="forceSingleLine">Status</th>
                                        <th className="forceSingleLine text-center">Export Flag</th>
                                        <th>Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        InvoiceCheckDetail?.map((res: any) => {
                                            return (
                                                <tr>
                                                    <td>{res?.accountCode}</td>
                                                    <td>{res?.invoiceNum}</td>
                                                    <td>{res?.periodNum}</td>
                                                    <td>{res?.homeValue}</td>
                                                    <td>{res?.netAmountProcessed}</td>
                                                    <td>{res?.amountPaidOut}</td>
                                                    <td>
                                                        {res?.approvalStatus && <span className="icon-btn edit  btn-s" >Approved</span>}
                                                        {!res?.approvalStatus && <span className="icon-btn delete  btn-s" >Approved</span>}
                                                    </td>
                                                    <td>{res?.exportFlag}</td>
                                                    <td>
                                                        <div className="width300">

                                                            <button className="icon-btn primary  btn-s" onClick={() => exportOptionSelect("Custom Distro Fee L2")} data-ng-click="exportPopupOptions(2, invoiceCheckLevel1.invoiceNum, 'Netsuite_DistroFee', invoiceCheckLevel1.periodNum)">
                                                                <i className=" icon-download1"></i> Distro Fee</button>

                                                            <button className="icon-btn primary  btn-s" onClick={() => exportOptionSelect("Custom disney L2")} data-ng-click="exportPopupOptions(2, invoiceCheckLevel1.invoiceNum)">
                                                                <i className=" icon-download1"></i>
                                                            </button>

                                                            <button className="icon-btn primary  btn-s" onClick={() => exportOptionSelect("Custom disney L2")} data-ng-click="exportPopupOptions(2, invoiceCheckLevel1.invoiceNum, 'Netsuite', invoiceCheckLevel1.periodNum)">
                                                                <i className=" icon-download1"></i>
                                                                {disney && <span>SAP</span>}
                                                                {!disney && <span >Netsuite</span>}
                                                            </button>

                                                        </div>

                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>}

                        </div>}

                        <div className="clearfix mt hide">
                            <div className="pull-right ws-2 mt " data-ng-show="displayBoxes">
                                <button className="icon-btn edit " ng-click="createInvoiceCheck()">
                                    <i className="icon-save"></i> Create
                                </button>

                            </div>

                            <div className="pull-right ws-2 " data-ng-show="displayBoxes">
                                <div className="input-group mt">
                                    <input type="number" placeholder="Enter percentage" ng-model="invoiceCheck.percentage" id="invoiceCheck.percentage" name="percentage" />
                                    <span className="ws-12 text-bold">%</span>

                                </div>
                            </div>

                            <div className="pull-right ws-3 " data-ng-show="displayBoxes">
                                <div className="input-group mt">
                                    <span className="ws-12 text-bold">Analysis</span>
                                    <select ng-model="invoiceCheck.mtchAnalysisCode" name="mtchAnalysisCode" id="invoiceCheck.mtchAnalysisCode">
                                        <option value="" >Choose an analysis code</option>
                                        <option value="0" label="ADVANCE">ADVANCE</option>
                                        <option value="7" label="MECHDEDUCT">MECHDEDUCT</option>
                                    </select>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete " onClick={onClose}><i className="icon-close"></i> Close</button>
                    </div>

                    {(() => {

                        if (exportOption) {
                            return <ExportOption exportOption={exportOption} onChange={onChangeExportOption} fileName={"Digital_accountexport"} />
                        }

                    })()}
                </div>
            </Drawer>
        </>
    )
}